module.exports = __webpack_public_path__ + "img/zoomed-out.bade7a79.png";